import { render, staticRenderFns } from "./BanForm.vue?vue&type=template&id=1b60d655"
import script from "./BanForm.vue?vue&type=script&lang=js"
export * from "./BanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports